module.exports = __webpack_public_path__ + "static/media/logo.049bdb1f.png";